import { FotografiaProductoId } from './FotografiaProductoId';
import { ProductoPresentacion } from './ProductoPresentacion';

export class FotografiaProducto {
    id: FotografiaProductoId;
    productoPresentacion: ProductoPresentacion;
    nombreFotografia: string;
    archivoBase64: string | ArrayBuffer;
    mimeType:string;
}